module.exports = __webpack_public_path__ + "img/image.7654ca70.svg";